export default "__VITE_ASSET__DfC1EBeb__"